import { InlineText1, InlineText2 } from '@cian/ui-kit';
import { IconProductWarning16, IconProductTrust16, IconProductEscrou16 } from '@cian/ui-kit-design-tokens/icons';
import classNames from 'clsx';

import { SalesStartTooltip } from '../../../SalesStartTooltip';

import * as styles from './styles.css';

interface IHouseItemProps {
  active: boolean;
  title: string;
  finishStatus?: string;
  isReliable?: boolean;
  hasProblems?: boolean;
  isEscrow?: boolean;
  isSalesStart?: boolean;
}

export function HouseItem({
  active,
  title,
  finishStatus,
  isReliable = false,
  hasProblems = false,
  isEscrow = false,
  isSalesStart = false,
}: IHouseItemProps) {
  return (
    <div className={classNames(styles['container'], active && styles['active'])}>
      <div className={styles['title']}>
        <InlineText1>{title}</InlineText1>
        <div className={styles['labels']}>
          {isReliable && <IconProductTrust16 color="icon-main-default" />}
          {hasProblems && <IconProductWarning16 color="icon-negative-default" />}
          {isEscrow && <IconProductEscrou16 color="icon-main-default" />}
          {isSalesStart && <SalesStartTooltip />}
        </div>
      </div>
      {finishStatus && <InlineText2 color="gray60_100">{finishStatus}</InlineText2>}
    </div>
  );
}
